// api/WikiDraftAPI.ts
import { registerMutation } from "@adornis/baseql/metadata/register.js";
import { getByID } from "@adornis/baseql/operations/mongo.js";
import { WikiEntry } from "../db/WikiEntry.js";
import { WikiEntryDraft } from "../db/WikiEntryDraft.js";
var wikiApplyDraft = registerMutation({
  type: () => String,
  operationName: "wikiApplyDraft",
  resolve: (draftID) => {
    return async () => {
      const draft = await getByID(
        WikiEntryDraft,
        draftID
      )({
        referenceID: 1,
        content: 1,
        title: 1,
        writePermission: 1,
        readPermission: 1,
        parentID: 1,
        updatedAt: 1,
        updatedAtBy: 1
      });
      if (!draft) {
        throw new Error("Draft not found");
      }
      const entry = await getByID(
        WikiEntry,
        draft.referenceID
      )({
        _id: 1,
        content: 1,
        title: 1,
        writePermission: 1,
        readPermission: 1,
        parentID: 1,
        updatedAt: 1,
        updatedAtBy: 1
      });
      if (!entry) {
        throw new Error("Entry not found");
      }
      entry.content = draft.content;
      entry.title = draft.title;
      entry.writePermission = draft.writePermission;
      entry.readPermission = draft.readPermission;
      entry.parentID = draft.parentID;
      entry.updatedAt = /* @__PURE__ */ new Date();
      entry.updatedAtBy = draft.updatedAtBy;
      await entry.save();
      await draft.remove();
      return entry._id;
    };
  },
  params: [{ type: () => String, name: "draftID" }]
});
var WikiDraftAPI;
((WikiDraftAPI2) => {
  WikiDraftAPI2.apply = wikiApplyDraft;
})(WikiDraftAPI || (WikiDraftAPI = {}));
export {
  WikiDraftAPI,
  wikiApplyDraft
};
